import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from 'src/layout/Page';

const Account: React.FC = (): React.ReactElement => {
	const { t } = useTranslation();

	return <Page
		pageClass={'personal-page'}
		pageHeader={`${t('pages.account.title')}`}>
		<>Account route</>
	</Page>;
};

export default Account;
